import { render } from "./LoginHero.vue?vue&type=template&id=55b1187a&scoped=true"
import script from "./LoginHero.vue?vue&type=script&lang=js"
export * from "./LoginHero.vue?vue&type=script&lang=js"

import "./LoginHero.vue?vue&type=style&index=0&id=55b1187a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55b1187a"]])

export default __exports__